import './App.css';
import './arch.css';
import './ddark.css';

import React, { useState, useRef } from 'react';

function App() {
  let [isRho, setIsRho] = useState(true);
  let [categories, setCategories] = useState(1);
  let [result, setResult] = useState('');

  let inputs = useRef(null);

  function clearInputs() {
    [...inputs.current.querySelectorAll('.input_field')].forEach(input => input.value = '');
  }

  function f2square(num) {
    return num * num;
  }
  
  function calculate() {
    let fields = [...inputs.current.querySelectorAll('.input_field')];

    let sigmaarr = [];
    let narr = [];
    let sarr = [];
    let rhoarr = [];

    for (let i = 0; i < fields.length; i += 4) {
      sigmaarr.push(Number(fields[i].value));
      narr.push(Number(fields[i + 1].value));
      sarr.push(Number(fields[i + 2].value));
      rhoarr.push(Number(fields[i + 3].value));
    }

    let i2 = sigmaarr.length;
    let this_f2 = 0.0;
    let sum1 = 0.0, sum2 = 0.0, sum3 = 0.0, sum4 = 0.0;
    for(let i = 0; i < i2; i++) {
        sum1 += ((narr[i] - 1) * f2square(rhoarr[i]) * f2square(sigmaarr[i]));
        sum2 += ((narr[i] - 1) * rhoarr[i] * sigmaarr[i] * sarr[i]);
        sum3 += ((narr[i] - 1) * f2square(sarr[i]));
        sum4 += ((narr[i] - 2) * f2square(sigmaarr[i]) * (1 - f2square(rhoarr[i])));
    }
    this_f2 = ((sum1 - (f2square(sum2) / sum3)) / sum4);

    setResult(this_f2);

    // rho = beta / (sigma / sx)
  }

  return (
    <div className="App b2 layer">
      <div style={{ width: '700px' }}>
        <p className="fsz15">Computation of Effect Size: Modified 𝑓²</p>
        <div className='row aic m5 p10' style={{ gap: '20px' }}>
          <span># of Sub-Groups</span>
          <input type='number' style={{ maxWidth: '100px', textAlign: 'center' }} value={categories} onChange={(ev) => setCategories(ev.target.value)} />
        </div>


        <div ref={inputs} className='p10 m5' style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '15px', alignItems: 'center' }}>
          <span>Sub-Group</span>
          <span>σ <sub>i</sub></span>
          <span>n <sub>i</sub></span>
          <span>S <sub>xi</sub></span>
          <span>{isRho ? 'ρ' : 'β'} <sub>i</sub></span>

          {
            Array.from({ length: categories }, (_, i) => (
              [
                <span>{i + 1}</span>,

                <InputField className='tac' />,
                <InputField className='tac' />,
                <InputField className='tac' />,
                <InputField className='tac' validator={(val) => {
                  let v = Number(val);

                  if (isNaN(v))
                    return 'This is not a valid number';

                  if (v <= -1 || v >= 1)
                    return 'Correlation must be between -1 and 1';
                  return false;
                }} />,
              ]
            ))
          }


          <span className='gspan2'>𝑓² = {Number(result).toFixed(4)}</span>
          <span></span>
          <button className='p10 b4 bold hb3' onClick={calculate}>Calculate</button>
          <button className='p10 b4 bold hb3' onClick={clearInputs}>Clear All</button>
        </div>
      </div>
    </div>
  );
}

function InputField({ className = '', validator }) {
  let [value, setValue] = useState('');
  let [invalid, setInvalid] = useState(false);

  function onChange(ev) {
    setValue(ev.target.value);

    if (validator)
      setInvalid(validator(ev.target.value))
    else
      setInvalid(isNaN(Number(ev.target.value)) ? 'This is not a valid number' : false);
  };

  return (
    <div className={`col ${className}`}>
      <input type="text" className={'input_field ' + className} value={value} onChange={onChange} />
      <span className={`cred ${invalid ? '' : 'nodisplay'}`}>{invalid}</span>
    </div>
  )
}


export default App;
